import { get } from "lodash";

export const getStoreFromSliceName = (state: any, sliceName: string) =>
  get(state, sliceName.split("/"), {});
